import { useDispatch } from 'react-redux';
import { AnnotationStatus } from '@rossum/api-client/shared';
import { Stack } from '@rossum/ui/material';
import { GridRenderCellParams } from '@rossum/ui/x-data-grid-pro';
import { constructDocumentUrl } from '../../../lib/url';
import { startValidation } from '../../../redux/modules/ui/actions';
import { metrics } from '../../../timers/metrics/metrics';
import { Filename } from './Filename';
import { StyledLink } from './StyledLink';

const DEFAULT_WIDTH = 170;

const RenderFilenameCell = (
  props: GridRenderCellParams<
    { id: number; status: AnnotationStatus; pages: unknown[] },
    string
  > & {
    onMouseOver: () => void;
    onMouseOut: () => void;
  }
) => {
  const { row, onMouseOver, onMouseOut, value: originalFileName } = props;

  const filenameActionsDisabled =
    row.status === 'failed_import' ||
    row.status === 'importing' ||
    row.pages.length === 0;

  const dispatch = useDispatch();

  const annotate = (url: string) =>
    dispatch(startValidation(url, props.api.getAllRowIds().map(Number)));

  const estimatedFilenameLength = props.colDef.width ?? DEFAULT_WIDTH;

  return (
    <Stack alignItems="center" direction="row" width="100%">
      <StyledLink
        to={constructDocumentUrl({ id: row.id })}
        onClick={e => {
          if (e.metaKey || e.ctrlKey) {
            return;
          }

          e.preventDefault();
          e.stopPropagation();

          if (!filenameActionsDisabled) {
            metrics.startAnnotationOpen(row.id);
            annotate(constructDocumentUrl({ id: row.id }));
          }
        }}
        sx={{
          height: '48px',
          display: 'flex',
          alignItems: 'center',
        }}
        disabled={filenameActionsDisabled}
        onMouseOver={!filenameActionsDisabled ? onMouseOver : undefined}
        onMouseLeave={!filenameActionsDisabled ? onMouseOut : undefined}
      >
        <Filename
          status={row.status}
          disabled={filenameActionsDisabled}
          estimatedFilenameLength={
            estimatedFilenameLength > 0 ? estimatedFilenameLength : 25
          }
          originalFileName={originalFileName}
        />
      </StyledLink>
    </Stack>
  );
};

export { RenderFilenameCell };
